<script setup lang="ts">
import DataTable from '@/onenetwork/components/datatable/DataTable.vue'
import DateTimeCell from '@/onenetwork/components/datatable/DateTimeCell.vue'
import NumberCell from '@/onenetwork/components/datatable/NumberCell.vue'
import TagCell from '@/onenetwork/components/datatable/TagCell.vue'
import TextCell from '@/onenetwork/components/datatable/TextCell.vue'
import { APIClient } from '@/onenetwork/core/onenetwork.api.instant'
import { onMounted, ref, watch } from 'vue'
import { FlashOfferAPI } from '../constants/flashoffer.api.uri.const'
import { formatTableDataFlashOffer, formatTableDataFlashOfferByBroker } from '../helper/table'
import BrokerAPI from '@/modules/broker/constants/broker.api.uri.const'
import { useRouter } from 'vue-router'

interface Props {
  account: any,
  currentTab?: string,
}

const props = defineProps<Props>()
const router = useRouter()
const loading = ref<boolean>(false)
const pageSize = ref(10)
const page = ref(1)
interface DataSource {
  list: any[];
  totalPage: number;
  totalRecords: number;
}

const dataSource = ref<DataSource>({
  list: [],
  totalPage: 0,
  totalRecords: 0,
})

const handleChangePage = (page: number) => {
  if (page !== page.value) {
    page.value = page
    requestFetchData()
  }
}

const handleChangePageSize = (size: number) => {
  if (size !== pageSize.value) {
    pageSize.value = size
    page.value = 1 // Reset to first page when changing page size
    requestFetchData()
  }
}

const requestFetchData = async () => {
  console.log(props.account, 'requestFetchData flash_offers_by_broker');

  try{
    const url = BrokerAPI.broker.flash_offers_by_broker
    const res = await APIClient.get(url, {
      params: {
        page: page.value,
        page_size: pageSize.value,
        // status[]=ongoing&sort[0][0]=created_at&sort[0][1]=desc&broker_id=4
        // status: ['ongoing'],
        sort: [['created_at', 'desc']],
        broker_id: props.account?.user_id
      }
    });

    const { data } = res.data;
    if (res.data.code === 200) {
      dataSource.value = {
        list: formatTableDataFlashOfferByBroker(data.data) || [],
        totalPage: data.last_page,
        totalRecords: data.total,
      }
    }
  } catch (e) {

  }
}

watch(() => props.currentTab, (newTab) => {
  if (newTab === '5') {
    requestFetchData()
  }
})

onMounted(() => {
  requestFetchData()
})

const handleGotoDetail = (e: MouseEvent, item: any) => {

  router.push({ name: 'flash-offer-detail', params: { id: item.id } })
  // flashOfferListStore.newTab({id: item.code, label: `#${item.code} - ${item.subject?.title}`, active: true})
}
</script>

<template>
  <data-table
    :loading="loading"
    :tableConfig="{
      canShowHide: false,
      columns: {
        id: { label: 'ID', component: TextCell, class: '', visible: true, sort: false, config: {} },
        started_at: { label: 'Ngày bắt đầu', component: DateTimeCell, class: '', visible: true, sort: '', config: {} },
        ended_at: { label: 'Ngày kết thúc', component: DateTimeCell, class: '', visible: true, sort: '', config: {} },
        status_text: { label: 'Trạng thái', component: TagCell, class: '', visible: true, sort: false, config: {} },
        name: { label: 'Tên sự kiện', component: TextCell, class: '', visible: true, sort: false, config: {} },
        total_items: { label: 'Số lượng mở bán', component: NumberCell, class: 'justify-end', visible: true, sort: false, config: {} },
        created_at: { label: 'Ngày đăng ký', component: DateTimeCell, class: '', visible: true, sort: 'desc', config: {} },
        created_by: { label: 'Người tạo', component: TextCell, class: '', visible: true, sort: false, config: {} },
      }
    }"
    :row-action-buttons="[
      { action: handleGotoDetail, css: 'btn btn-cs', label: 'Chi tiết', icon: 'iconamoon:edit-duotone' }
    ]"
    :page-size="pageSize"
    :page="page"
    :total-page="dataSource?.totalPage || 0"
    :total-records="dataSource?.totalRecords || 0"
    :data="dataSource?.list || []"
    @page-changed="handleChangePage"
    @pagesize-changed="handleChangePageSize"

  />
</template>

<style scoped>

</style>
